<div class="padded-side-nav page-container">
    <div [@expandCollapse]="isInfoTilesCollapsed ? 'collapsed' : 'expanded'" class="info-tiles-container">
        @if (!tilesLoading) {
          <div class="info-tiles-header">
            @if(tilesUpdatedAt!=null){
              <div class="tiles-updated-at">
                  <p>Last Updated At: {{tilesUpdatedAt}}</p>
                  <button mat-icon-button (click)="refreshDashboard()">
                      <mat-icon>refresh</mat-icon>
                  </button>
              </div>
            }
            <div class="info-tiles">
                @for (elem of infoTileData; track $index) {
                <mat-card class="info-tile">
                    <h3>{{elem.heading}}</h3>
                    @for (innerElem of elem.data; track $index) {
                    <div class="progress-tracker">
                        @if (innerElem.title != 'Unknown') {
                        @if (innerElem.value > 0) {
                        <div class="progress-headers clickable" (click)="onTileClick(elem.heading, innerElem.title)">
                            <p>{{innerElem.title}}</p>
                            <p>{{innerElem.value}}</p>
                        </div>
                        } @else {
                        <div class="progress-headers ">
                            <p>{{innerElem.title}}</p>
                            <p>{{innerElem.value}}</p>
                        </div>
                        }
                        <mat-progress-bar class="progress-bar" [value]="innerElem.value / elem.total * 100"
                            [style]="innerElem.color != undefined?'--mdc-linear-progress-active-indicator-color:'+innerElem.color+';':''"></mat-progress-bar>
                        }
                        @if (innerElem.title == 'Unknown') {
                        <br>
                        <div class="progress-headers">
                            <p>{{innerElem.title}}</p>
                            <p>{{innerElem.value}}</p>
                        </div>
                        }
                    </div>
                    }
                </mat-card>
                }
                <mat-card class="total-tile">
                    <h3>TOTAL DEVICES</h3>
                    <h2>{{totalTileData.total}}</h2>
                    <p>{{totalTileData.date}}</p>
                </mat-card>
            </div>
          </div>
        }@else {
        <div class="loader">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        }
    </div>

    <div class="toggle-container" [ngClass]="{ collapsed: isInfoTilesCollapsed }">
        <div class="toggle-divider-line"></div>
        <button mat-icon-button (click)="toggleInfoTiles()" class="toggle-button">
            <mat-icon>{{ isInfoTilesCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
        </button>
        <div class="toggle-divider-line"></div>
    </div>

    <div class="action-container">
        <div style="width:90%;">
            <app-generic-table-header #tableHeader [config]="headerConfig" (refreshEvent)="setFilter($event)"
                (exportPressed)="generateReport()" [savedSearch]="searchTerm" [savedFilters]="appliedFilters">
            </app-generic-table-header>
        </div>
        <div style="width: 5%;">
            <button matTooltipShowDelay="500" [disabled]="selectedDevices.length<=0 && !allSelected"
                matTooltip="Reboot Selected Devices" mat-mini-fab
                [ngClass]="selectedDevices.length<=0 && !allSelected?'disabled-button':'mini-buttons'"
                (click)="rebootDevices()">
                <mat-icon> restart_alt </mat-icon>
            </button>
        </div>
        @if (isHIP && isHipTeltonikaAdmin()) {
        <div style="width: 5%;">
            <button matTooltipShowDelay="500"
                [disabled]="((selectedDevices.length<=0 && !allSelected) || selectedContainsDisabledDevice())"
                matTooltip="Run Teltonika Task" mat-mini-fab
                [ngClass]="((selectedDevices.length<=0 && !allSelected) || selectedContainsDisabledDevice())?'disabled-button':'mini-buttons'"
                (click)="runTeltonikaTask()">
                <mat-icon> terminal </mat-icon>
            </button>
        </div>
        <div style="width: 5%;">
            <button matTooltipShowDelay="500" [disabled]="selectedDevices.length<=0 && !allSelected"
                matTooltip="Select Tag" mat-mini-fab
                [ngClass]="selectedDevices.length<=0 && !allSelected?'disabled-button':'mini-buttons'"
                (click)="selectTagMultipleDevices()">
                <mat-icon> sell </mat-icon>
            </button>
        </div>
        <div style="width: 5%;">
            <button matTooltipShowDelay="500" matTooltip="HIP Config Tool" mat-mini-fab [ngClass]="'mini-buttons'"
                (click)="openUpdateTeltonikaDevice()">
                <mat-icon> upload </mat-icon>
            </button>
        </div>
        }
    </div>
    @if(showTable){
    @if(isHIP){
    <tools-table ApiPath="/teltonika/advanced/" [Headers]="headers" #table [Search]="false" [SortColumn]="sortColumn"
        [PrimaryColumn]="'TeltonikaCustomName'" [HTTPPost]="true" [HTTPData]="getHTTPData()" [SavedSearch]="searchTerm"
        [Actions]="actions" [Desc]="sortDesc" [Slim]="true" [DisplayCount]="10" ExtraQuery="?teltonika=true"
        [Selectable]="true" [Multiple]="true" (Selected)="addSelected($event)" [sideTagConfig]="sideTagConfig"
        [CheckOptions]="deviceReachableOptions" [radioButtonStyle]="'text-center'" [radioButtonFloat]="'none'"
        (CheckOptionChanged)="statusChanged($event)" [SelectedCheckOption]="reachableStatus" [SelectAll]="true"
        (AllSelected)="allDevicesSelected($event)" [SelectPage]="true" [PageSizeOptions]="[10,25,50]"
        [IncludeAllPageSize]="true">
    </tools-table>
    } @else {
    <tools-table ApiPath="/teltonika/advanced/" [Headers]="headers" #table [Search]="false" [SortColumn]="sortColumn"
        [PrimaryColumn]="'TeltonikaCustomName'" [HTTPPost]="true" [HTTPData]="getHTTPData()" [SavedSearch]="searchTerm"
        [Actions]="actions" [Desc]="sortDesc" [Slim]="true" [DisplayCount]="10" ExtraQuery="?teltonika=true"
        [Selectable]="true" [Multiple]="true" (Selected)="addSelected($event)" [sideTagConfig]="sideTagConfig"
        [CheckOptions]="deviceReachableOptions" [radioButtonStyle]="'text-center'" [radioButtonFloat]="'none'"
        (CheckOptionChanged)="statusChanged($event)" [SelectedCheckOption]="reachableStatus" [SelectAll]="true"
        (AllSelected)="allDevicesSelected($event)" [SelectPage]="true" [PageSizeOptions]="[10,25,50]"
        [IncludeAllPageSize]="true">
    </tools-table>
    }

    }@else {
    <mat-spinner [diameter]="40"></mat-spinner>
    }
</div>
